import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormControl, FormGroup } from '@angular/forms';
import { formatApiDate } from '../products/production-launch.service';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  private readonly http = inject(HttpClient);

  formFilterList = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    granularity: new FormControl(''),
  });

  overview(payload: {
    dateFrom?: string;
    dateTo?: string;
    granularity?: string;
  }) {
    let params = new HttpParams()

    if (payload.dateFrom) {
      params = params.set(
        'dateFrom',
        formatApiDate(payload.dateFrom)
      );
    }

    if (payload.dateTo) {
      params = params.set(
        'dateTo',
        formatApiDate(payload.dateTo)
      );
    }

    if (payload.granularity) {
      params = params.set('granularity', payload.granularity);
    }

    return this.http.get<any>(
      `${environment.api}/dashboard/overview`, { params }
    );
  }

  salesEvolution(payload: {
    dateFrom?: string;
    dateTo?: string;
    granularity?: string;
  }) {
    let params = new HttpParams()

    if (payload.dateFrom) {
      params = params.set(
        'dateFrom',
        formatApiDate(payload.dateFrom)
      );
    }

    if (payload.dateTo) {
      params = params.set(
        'dateTo',
        formatApiDate(payload.dateTo)
      );
    }

    if (payload.granularity) {
      params = params.set('granularity', payload.granularity);
    }

    return this.http.get<any>(
      `${environment.api}/dashboard/sales-timeseries`, { params }
    );
  }

  salesComparison(payload: {
    dateFrom?: string;
    dateTo?: string;
    granularity?: string;
  }) {
    let params = new HttpParams()

    if (payload.dateFrom) {
      params = params.set(
        'dateFrom',
        formatApiDate(payload.dateFrom)
      );
    }

    if (payload.dateTo) {
      params = params.set(
        'dateTo',
        formatApiDate(payload.dateTo)
      );
    }

    if (payload.granularity) {
      params = params.set('granularity', payload.granularity);
    }

    return this.http.get<any>(
      `${environment.api}/dashboard/sales-comparison`, { params }
    );
  }
}
